import { AlertCircle, Building2, CheckCircle2, Clock, DoorOpen, FileText, Monitor, Users } from 'lucide-react';

export const getStatusConfig = (status: string) => {
  const map: Record<string, { label: string; bg: string; text: string; icon: any }> = {
    PAID: { label: 'Payé', bg: 'bg-emerald-100', text: 'text-emerald-700', icon: CheckCircle2 },
    CONFIRMED: { label: 'Confirmé', bg: 'bg-blue-100', text: 'text-blue-700', icon: CheckCircle2 },
    PENDING: { label: 'En attente', bg: 'bg-slate-100', text: 'text-slate-700', icon: Clock },
    QUOTE_REQUESTED: { label: 'Devis Demandé', bg: 'bg-amber-100', text: 'text-amber-700', icon: FileText },
    PAYMENT_PENDING: { label: 'Paiement en attente', bg: 'bg-orange-100', text: 'text-orange-700', icon: Clock },
    QUOTED: { label: 'Devis envoyé', bg: 'bg-amber-100', text: 'text-amber-700', icon: FileText },
    APPROVED: { label: 'Approuvé', bg: 'bg-blue-100', text: 'text-blue-700', icon: CheckCircle2 },
    REJECTED: { label: 'Rejeté', bg: 'bg-red-100', text: 'text-red-700', icon: AlertCircle },
    CANCELLED: { label: 'Annulé', bg: 'bg-slate-100', text: 'text-slate-700', icon: AlertCircle },
    COMPLETED: { label: 'Terminé', bg: 'bg-emerald-100', text: 'text-emerald-700', icon: CheckCircle2 },
    URGENT: { label: 'URGENT', bg: 'bg-red-100', text: 'text-red-700', icon: Clock },
    OVERDUE: { label: 'EN RETARD', bg: 'bg-[#8E0B56]', text: 'text-white', icon: Clock }, // SING MAGENTA
  };
  return map[status] || { label: status, bg: 'bg-slate-100', text: 'text-slate-700', icon: AlertCircle };
};

export const getTypeLabel = (type: string) => {
  const map: Record<string, { label: string; icon: any }> = {
    COWORKING: { label: 'Coworking', icon: Monitor },
    MEETING_ROOM: { label: 'Salle de réunion', icon: Users },
    PRIVATE_OFFICE: { label: 'Bureau privatif', icon: DoorOpen },
    EVENT_SPACE: { label: 'Espace Évènementiel', icon: Building2 },
    OTHER: { label: 'Autres Espaces', icon: Building2 },
  };
  return map[type] || { label: type, icon: Building2 };
};
